import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { ProductListItemClickHandle } from './ProductList'
import styled from 'styled-components'
import { SmallTypeSelect } from './SmallTypeSelect'
import Image from 'next/image'
import { Checkbox } from 'antd'
import { themeGet } from '@styled-system/theme-get'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import Link from 'next/link'
import { mixpanelEvent } from '@/lib/mixpanels/mixpanel'

export interface ProductTypeSearchResultProps {
	onItemClick: ProductListItemClickHandle
	onEmptyClick: () => void
	sorting: (sort: SortState) => void
	parsing: (parse: ParseState) => void
	parsingState: ParseState
	onSelectAll: (checked: boolean) => void
	sortStatus: SortState
	totalCount: number
	category?: string
	useParsingBadge: boolean
}

export type SortState = 'price' | 'korean' | 'new' | 'accurate'
export type ParseState = 'Y' | 'N'
const FilterName = styled.div<{ active?: boolean }>`
	cursor: pointer;
	font-size: 14px;
	color: ${({ active }) => (active ? `#002fa8` : `black`)};
	font-weight: ${({ active }) => (active ? 'bold' : 'normal')};
`
export const ProductTypeSearchResultHeader = observer<ProductTypeSearchResultProps>(
	({
		onItemClick,
		onEmptyClick,
		sorting,
		parsing,
		parsingState,
		onSelectAll,
		sortStatus,
		totalCount,
		category,
		useParsingBadge,
	}) => {
		const [activeTap, setActiveTap] = useState<string>(sortStatus)

		const handleParsing = (e: CheckboxChangeEvent) => {
			parsing(e.target.checked ? 'Y' : 'N')
		}
		const handleChangeTap = (sort: SortState) => {
			setActiveTap(sort)
			sorting(sort)
		}
		return (
			<ProductTypeWrapper>
				{/* 편집가능 체크박스 - 우선 수업자료만 보이도록 */}
				{useParsingBadge && category === 'handout' && (
					<div className="parsing-badge">
						<Checkbox
							defaultChecked={parsingState === 'Y'}
							onChange={(e) => {
								handleParsing(e)
							}}>
							<Image
								src={'/static/assets/label-edit.svg'}
								alt={'parsing badge'}
								width={75}
								height={20}
								className={'badge-img'}
							/>
							<span className={'badge-desc'}>자료만 보기</span>
						</Checkbox>
						<div className={'promotion-tooltip'}>
							<div className="tooltip-inner">
								<div className="back"></div>
								<Link
									onClick={() => mixpanelEvent('Studio List Tooltip Clicked')}
									href={'https://promotion.solvook.com/promotions/studio'}
									target={'_blank'}>
									편집가능한 자료란?
								</Link>
							</div>
						</div>
					</div>
				)}

				{/* [웹용] 정확도순/최신순/이름순/낮은가격순 탭형 버튼 */}
				<div className="inner w">
					{/*<Checkbox*/}
					{/*	onChange={(e) => {*/}
					{/*		const checked = e.target.checked*/}
					{/*		onSelectAll(checked)*/}
					{/*	}}>*/}
					{/*	전체선택*/}
					{/*</Checkbox>*/}
					<div className={'filterWrapper'}>
						{/*<FilterName*/}
						{/*	active={activeTap === 'accurate'}*/}
						{/*	onClick={() => handleChangeTap('accurate')}*/}
						{/*	className={'filterName'}>*/}
						{/*	정확도순{' '}*/}
						{/*</FilterName>*/}
						{/*<span className={'line'}> | </span>*/}
						<FilterName
							active={activeTap === 'new'}
							onClick={() => handleChangeTap('new')}
							className={'filterName'}>
							최신순{' '}
						</FilterName>
						<span className={'line'}> | </span>
						{/*<FilterName*/}
						{/*	active={activeTap === 'korean'}*/}
						{/*	onClick={() => handleChangeTap('korean')}*/}
						{/*	className={'filterName'}>*/}
						{/*	이름순{' '}*/}
						{/*</FilterName>*/}
						{/*<span className={'line'}> | </span>*/}
						<FilterName
							active={activeTap === 'price'}
							onClick={() => handleChangeTap('price')}
							className={'filterName'}>
							낮은가격순{' '}
						</FilterName>
					</div>
				</div>

				{/* [모바일용] 정확도순/최신순/이름순/낮은가격순 셀렉박스 */}
				<div className="inner m">
					<div className="total">총 {totalCount}건</div>
					<SmallTypeSelect
						defaultValue={sortStatus}
						onChange={(key: SortState) => handleChangeTap(key)}
						options={[
							// {
							// 	value: 'accurate',
							// 	label: '정확도순',
							// },
							{
								value: 'new',
								label: '최신순',
							},
							// {
							// 	value: 'korean',
							// 	label: '이름순',
							// },
							{
								value: 'price',
								label: '낮은가격순',
							},
						]}
					/>
				</div>
			</ProductTypeWrapper>
		)
	},
)

const ProductTypeWrapper = styled.div<{ active?: boolean }>`
	position: relative;

	.parsing-badge {
		position: absolute;
		top: 0;
		left: 0;

		@media (max-width: 1200px) {
			position: relative;
			padding: 0 16px;
			margin-top: -4px;
			margin-bottom: 6px;
		}

		.ant-checkbox-wrapper {
			display: flex;
			align-items: center;

			& > span {
				display: block;

				&.ant-checkbox {
					margin-top: -6px;
				}

				&:not(.ant-checkbox) {
					display: flex;
					gap: 4px;
					padding-left: 4px;

					.badge-img {
					}
					.badge-desc {
						font-size: 14px;
						color: ${themeGet('text.0', '#1B1B29')};
						line-height: 20px;
					}
				}
			}
		}

		@media (hover: hover) {
			&:hover .promotion-tooltip {
				visibility: visible;
				opacity: 1;
			}
		}

		.promotion-tooltip {
			visibility: hidden;
			opacity: 0;
			position: absolute;
			top: 20px;
			left: 50%;
			transform: translateX(calc(-50% - 5px));
			z-index: 9;
			transition: all 0.2s;

			@media (max-width: 1200px) {
				display: none;
			}

			.tooltip-inner {
				position: relative;
				padding-top: 20px;

				.back {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					z-index: 1;
					background-color: #fff;
				}

				a {
					position: relative;
					display: block;
					width: 160px;
					height: 40px;
					font-size: 16px;
					font-weight: bold;
					color: #fff;
					text-align: center;
					line-height: 38px;
					border-radius: 4px;
					background-color: ${themeGet('primary.1', '#00bfc8')};
					transition: all 0.2s;
					z-index: 9;

					@media (hover: hover) {
						&:hover {
							opacity: 0.7;
						}
					}

					&:before,
					&:after {
						display: block;
						content: '';
						width: 16px;
					}

					&:before {
						position: absolute;
						top: -12px;
						left: 50%;
						width: 0;
						height: 0;
						border-left: 8px solid transparent;
						border-right: 8px solid transparent;
						border-bottom: 12px solid #00bfc8;
						transform: translateX(-50%);
					}

					&:after {
						display: inline-block;
						vertical-align: text-top;
						height: 16px;
						margin-top: 4px;
						background: url('/static/assets/ico-right-white.svg') no-repeat 50% 50%;
					}
				}
			}
		}
	}

	.inner {
		display: flex;
		justify-content: space-between;
		padding-bottom: 16px;
		&.w {
			justify-content: flex-end;
			padding-bottom: 24px;
		}
		&.m {
			display: none;
			padding: 0 36px;

			.total {
				font-size: 16px;
				font-weight: 600;
				color: #bbbbbf;

				@media (max-width: 1200px) {
				}
				@media (max-width: 768px) {
					font-size: 14px;
				}
			}

			.ant-select {
				width: 100px;

				.ant-select-selector {
					.ant-select-selection-item {
						text-align: right;
					}
				}

				@media (max-width: 768px) {
					width: 92px;
				}
			}
		}

		@media (max-width: 1200px) {
			&.w {
				display: none;
			}
			&.m {
				display: flex;
				align-items: center;
				justify-content: space-between;
			}
		}
		@media (max-width: 768px) {
			&.m {
				padding: 0 16px;
			}
		}
	}
	.filterWrapper {
		display: flex;
	}

	.line {
		margin: 0 6px;
		color: #f0f0f0;
	}
`
